import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { userSelectors } from 'reducers';

import { useSubscriptionFormSignatureStatus } from 'utils/hooks';
import { stepStatus } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import TunnelStep from '../../common/TunnelStep';
import SubscriptionFormSignature from './SubscriptionFormSignature';
import SubscriptionFormPreview from './SubscriptionFormPreview';

const tabs = {
    GENERATION: 'generation',
    SIGNING: 'signing',
};

const SubscriptionForm = props => {
    const { userStep } = props;

    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);

    const [currentTab, setCurrentTab] = useState(tabs.GENERATION);
    const subscriberHasSigned = useSubscriptionFormSignatureStatus(tunnelSubscription); // both need to have signed for co-subscriptions
    const mainSubscriberHasSigned = useMemo(
        () => userStep?.status === stepStatus.SIGNED_BY_INVESTOR,
        [userStep]
    );
    const stepTitle = useMemo(() => {
        if (currentTab === tabs.GENERATION) {
            return texts.SUBSCRIPTION_FORM_GENERATION;
        }
        if (tunnelSubscription?.withCoSubscriber) {
            return mainSubscriberHasSigned
                ? texts.SUBSCRIPTION_FORM_SIGNATURE_COSUBSCRIBER
                : texts.SUBSCRIPTION_FORM_SIGNATURE_INVESTOR;
        } else {
            return texts.SUBSCRIPTION_FORM_SIGNATURE;
        }
    }, [currentTab, tunnelSubscription, mainSubscriberHasSigned]);

    const handleToggle = useCallback(
        () =>
            setCurrentTab(prevState =>
                prevState === tabs.GENERATION ? tabs.SIGNING : tabs.GENERATION
            ),
        []
    );

    useEffect(() => {
        if (subscriberHasSigned) setCurrentTab(tabs.SIGNING);
    }, [subscriberHasSigned]);

    return (
        <TunnelStep maxWidth={960} title={stepTitle}>
            {currentTab === tabs.GENERATION ? (
                <SubscriptionFormPreview userStep={userStep} handleToggle={handleToggle} />
            ) : (
                <SubscriptionFormSignature
                    userStep={userStep}
                    handleToggle={handleToggle}
                    mainSubscriberHasSigned={mainSubscriberHasSigned}
                />
            )}
        </TunnelStep>
    );
};

SubscriptionForm.propTypes = { userStep: PropTypes.object };

export default SubscriptionForm;
